import React from 'react';
import { Pagination } from '@oneaudi/unified-web-components';
import { useI18n } from '@oneaudi/i18n-context';
import { PaginationContainer } from './styles';

interface EquipmentsPaginationProps {
  totalPages: number;
  current: number;
  onPageChange: (eventName: 'prev' | 'next') => void;
}

export const EquipmentsPagination: React.FC<EquipmentsPaginationProps> = ({
  totalPages,
  current,
  onPageChange,
}) => {
  if (totalPages === 1) {
    return null;
  }
  const nextPageAriaLabel = useI18n({
    id: 'nemo.ui.sc.details.aoz.products.pagination.next',
    defaultMessage: '',
  });

  const previousPageAriaLabel = useI18n({
    id: 'nemo.ui.sc.details.aoz.products.pagination.previous',
    defaultMessage: '',
  });

  const onPrevClick = () => {
    onPageChange('prev');
  };

  const onNextClick = () => {
    onPageChange('next');
  };

  return (
    <PaginationContainer data-testid="pagination">
      <Pagination
        variant="compact"
        itemCount={totalPages}
        current={current + 1}
        incrementElement={{
          'aria-label': nextPageAriaLabel,
          onClick: onNextClick,
        }}
        decrementElement={{
          'aria-label': previousPageAriaLabel,
          onClick: onPrevClick,
        }}
      />
    </PaginationContainer>
  );
};
